import type { AllRouteEndpoints } from "../routeTypes";

export const appsCatalogsCatalogIdFilteredSetsFilteredSetName =
  "/apps/catalogs/:catalog_id/filtered_sets/:filtered_set_name";

export const appsCatalogsCatalogIdFilteredSetsFilteredSetNameCacheKeys: AllRouteEndpoints[] = [
  "/apps/catalog_filtered_sets",
  "/apps/catalog_filtered_set_items_datatable",
  "/apps/catalog_items_datatable",
  // The filtered-set detail query is intentionally excluded here.
  // The PATCH is processed asynchronously by a Sidekiq job, so an immediate refetch would return
  // pre-update data. Invalidation of this query (without a refetch) is handled in useCreateFilteredSet
  // so the next navigation back to the selection triggers a fresh GET once Sidekiq has finished.
];
